import * as React from 'react'
import styled from 'styled-components'

const ContentWrapper = styled.div``

const Title = styled.h2`
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
  margin-top: 0;
`

const Description = styled.p`
  font-size: 0.875rem;
`

const PrivacyPolicyLink = styled.a`
  color: var(--color-primary);
`

export const websitePrivacyLink =
  process.env.REACT_APP_BASE_URL + '/webview/ayalamalls-website-privacy'

export const ConsentTitle = () =>
  `Cardholder Consent and Transaction Monitoring`

export const ConsentDescription = () => (
  <>
    By registering and linking a payment card, you consent to and authorize
    AyalaLand Malls, Inc. (ALMI), (the “Company”) to share your personal data
    and payment card information with Mastercard and/or VISA for the purposes of
    this program. You also consent to and authorize Mastercard and/or VISA to
    monitor transactions on your registered card(s) to determine when you have
    made a qualifying transaction, and for Mastercard and/or VISA to share or
    transfer (including any overseas transfers) such transaction details
    (including any personal data) with/to the Company, and third-party
    developers for the purposes of this program, and to enable card-linked
    offer(s) and target offers that may be of interest to you. For information
    about the Company’s privacy practices, please see&nbsp;
    <PrivacyPolicyLink
      href={websitePrivacyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Notice
    </PrivacyPolicyLink>
    .&nbsp;In addition to your rights as stated in the&nbsp;
    <PrivacyPolicyLink
      href={websitePrivacyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Notice
    </PrivacyPolicyLink>
    ,&nbsp; you may opt-out of transaction monitoring on the payment card(s) you
    entered at any time by deleting your card from your profile.
  </>
)

function CardConsent(props) {
  return (
    <ContentWrapper {...props}>
      <Title>
        <ConsentTitle />
      </Title>
      <Description>
        <ConsentDescription />
      </Description>
    </ContentWrapper>
  )
}

export default CardConsent
